// Header Scroll Enhancement
// Adds 'scrolled' class to sticky header when user scrolls down

document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.\\#header.\\@sticky');
    
    if (header) {
        let lastScrollY = 0;
        let ticking = false;
        
        function updateHeader() {
            if (window.scrollY > 50) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
            ticking = false;
        }
        
        window.addEventListener('scroll', function() {
            lastScrollY = window.scrollY;
            
            if (!ticking) {
                window.requestAnimationFrame(function() {
                    updateHeader();
                });
                ticking = true;
            }
        });
        
        // Initial check
        updateHeader();
    }
});

